import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";

export namespace WarehouseLocationValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            supervisorId: baseVals.string(),
            address: baseVals.string(),
            notes: v.optional(baseVals.string()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            supervisorId: v.exactOptional(baseVals.string()),
            address: v.exactOptional(baseVals.string()),
            notes: v.exactOptional(baseVals.string()),
        }),
    );
}
